import React, { Component } from 'react'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
} from 'react-google-maps'
import { compose, withStateHandlers, withHandlers, lifecycle } from 'recompose'
import './style.sass'
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer'

class Map extends Component {
  state = {
    selectedItem: this.props.selectedItem,
  }

  componentWillReceiveProps(nextProps) {
    this.props.onUpdate(nextProps.punti)

    if (!this.props.selectedItem && nextProps.selectedItem) {
      this.setState({ selectedItem: nextProps.selectedItem })
      this.props.onToggleOpen(nextProps.selectedItem)
    }

    if (
      this.props.selectedItem &&
      nextProps.selectedItem &&
      nextProps.selectedItem.nome !== this.props.selectedItem.nome
    ) {
      this.setState({ selectedItem: nextProps.selectedItem })
      this.props.onToggleOpen(nextProps.selectedItem)
    }
  }

  render() {
    const {
      punti,
      isMarkerShown,
      onToggleOpen,
      openMarker,
      onMarkerClick,
    } = this.props

    const { selectedItem } = this.state

    return (
      <GoogleMap
        defaultZoom={this.props.zoom}
        zoom={this.props.zoom}
        defaultCenter={{
          lat: punti.length > 0 ? punti[0].coordinate.latitude : 46813187.8,
          lng: punti.lenght > 0 ? punti[0].coordinate.longitude : 22421.6,
        }}
        ref={ref => this.props.onMapMounted(ref, this.props.punti)}
      >
        <MarkerClusterer
          onClick={this.props.onMarkerClustererClick}
          averageCenter
          enableRetinaIcons
          gridSize={60}
        >
          {isMarkerShown &&
            punti.map((punto, i) => (
              <Marker
                key={i}
                position={{
                  lat: punto.coordinate.latitude,
                  lng: punto.coordinate.longitude,
                }}
                onClick={() => {
                  onToggleOpen(punto)
                  onMarkerClick()
                }}
              >
                {openMarker && openMarker.nome === punto.nome && (
                  <InfoWindow onCloseClick={() => onToggleOpen(punto)}>
                    <div>
                      <div className="InfoWindow__Immagine">
                        {punto.immagineAssociata && (
                          <img
                            src={punto.immagineAssociata.resolutions.src}
                            style={{ height: '130px' }}
                          />
                        )}
                      </div>
                      <div className="InfoWindow__Testo">
                        <h2 className="InfoWindow__Nome">{punto.nome}</h2>
                        {punto.date && (
                          <h3 className="InfoWindow__Date">{punto.date}</h3>
                        )}
                      </div>
                    </div>
                  </InfoWindow>
                )}
              </Marker>
            ))}
        </MarkerClusterer>
      </GoogleMap>
    )
  }
}

export default compose(
  withStateHandlers(
    () => ({
      openMarker: undefined,
    }),
    {
      onToggleOpen: punto => punto => {
        return {
          openMarker: punto,
        }
      },
    }
  ),
  withHandlers({
    onMarkerClustererClick: () => markerClusterer => {
      const clickedMarkers = markerClusterer.getMarkers()
      console.log(`Current clicked markers length: ${clickedMarkers.length}`)
      console.log(clickedMarkers)
    },
  }),
  lifecycle({
    componentWillMount() {
      const refs = {}
      let mounted = false

      const fitBounds = punti => {
        const bounds = new google.maps.LatLngBounds()

        if (punti.length > 0) {
          punti.forEach(punto =>
            bounds.extend(
              new google.maps.LatLng(
                punto.coordinate.latitude,
                punto.coordinate.longitude
              )
            )
          )
        } else {
          // Se non ci sono punti, centro sulla svizzera
          // (trick, includo Lione e Monaco nei bounds perchè sennò non si centra)
          bounds.extend(new google.maps.LatLng(45.7578137, 4.8320114))
          bounds.extend(new google.maps.LatLng(48.1371079, 11.5753822))
        }

        refs.map.fitBounds(bounds)
      }

      this.setState({
        zoom: 15,
        onMapMounted: (ref, punti) => {
          if (mounted) {
            return
          }

          mounted = true
          refs.map = ref

          if (ref && punti) {
            fitBounds(punti)
          }
        },
        onUpdate: punti => {
          fitBounds(punti)
        },
      })
    },
  }),
  withScriptjs,
  withGoogleMap
)(Map)



// WEBPACK FOOTER //
// ./src/components/map/index.js